/** Currently used in the unit tests to check if string matches the expected ISO date string
 * Typically ISO date has the format of "YYYY-MM-DDTHH:MM:SS.sssZ" but this function is more lenient and also checks for the format "YYYY-MM-DDTHH:MM:SSZ"
 */
export function isIsoDate(str: string) {
    if (!(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str) || /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/.test(str))) {
        return false;
    }
    const d = new Date(str);

    return d instanceof Date && !Number.isNaN(d.getTime()) && d.toISOString().substring(0, 19) === str.substring(0, 19);
}
